import React from 'react';
import VoiceChat from './components/VoiceChat';
import './App.css';

function App() {
  return (
    <div className="App">
      <VoiceChat />
    </div>
  );
}

export default App;